import React, { useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router";
import styles from "./index.module.scss";
import LoginByAccount from "./components/LoginByAccount";
import LoginByMobile from "./components/LoginByMobile";
import LoginByDingDing from "./components/LoginByDingDing";
import AuthStore from "../../stores/AuthStore";

const LoginPage: React.FC = (props) => {
  const [loginType, setLoginType] = useState(3);
  const [isAnimationEnd, setIsAnimationEnd] = useState(false);
  // const [isFirstAnimationEnd, setIsFirstAnimationEnd] = useState(false);
  const [isAnimationEndDelay, setIsAnimationEndDelay] = useState(false);
  const videoRef = useRef<HTMLVideoElement>(null);
  const navigate = useNavigate();
  const { ssoIsLogin } = AuthStore;
  useEffect(() => {
    if (ssoIsLogin) {
      navigate("/");
    }
  }, []);
  return (
    <div
      className={styles.auth_page}
      onClick={() => {
        if (videoRef.current && !isAnimationEnd) {
          videoRef.current.currentTime = 3.8;
          // videoRef.current.play();
          // videoRef.current.pause();
          setIsAnimationEnd(true);
          setTimeout(() => {
            setIsAnimationEndDelay(true);
          }, 150);
          // setIsFirstAnimationEnd(true);
        }
      }}
    >
      {/* <img
        src={`${process.env.PUBLIC_URL}/imgs/loginImg.jpg`}
        style={{
          position: "fixed",
          display: isFirstAnimationEnd ? "" : "none",
        }}
      ></img> */}

      <video
        id="v1"
        autoPlay
        muted
        // loop={isFirstAnimationEnd ? true : false}
        ref={videoRef}
        className={styles.video}
        onEnded={() => {
          if (videoRef?.current) {
            videoRef.current.currentTime = 5.5;
            videoRef.current.play();
          }
        }}
        onPlay={() => {
          setTimeout(() => {
            setIsAnimationEnd(true);
          }, 3.8 * 1000);
          setTimeout(() => {
            setIsAnimationEndDelay(true);
          }, 3.95 * 1000);
        }}
        src={`${process.env.PUBLIC_URL}/loginVedio.mp4`}
        // style={{ mixBlendMode: isFirstAnimationEnd ? "screen" : "normal" }}
      ></video>

      <p
        className={styles.main_title}
        style={{ display: isAnimationEnd ? "" : "none" }}
      >
        POPSMART
      </p>
      <p
        className={styles.sub_title}
        style={{ display: isAnimationEndDelay ? "" : "none" }}
      >
        统一登录平台
      </p>

      <div
        className={styles.auth_form}
        style={{ display: isAnimationEnd ? "" : "none" }}
      >
        {loginType === 1 ? (
          <LoginByAccount setLoginType={(index) => setLoginType(index)} />
        ) : loginType === 2 ? (
          <LoginByMobile setLoginType={(index) => setLoginType(index)} />
        ) : (
          <LoginByDingDing setLoginType={(index) => setLoginType(index)} />
        )}
        <div className={styles.bottom}>宝略科技（浙江）有限公司</div>
      </div>
    </div>
  );
};

export default LoginPage;
